export interface IAttribute {
  id: number;
  name: string;
  type: string;
  ordinal: number;
}
